import React from "react";
import { QuestionnaireType } from "@/components/controls/Questionnaires/Questionnaire";
import {
  GeneralIllustration,
  YesNo,
  Mapping,
  TE,
  TEApproval
} from "@dreamhub/designsystem/icons";

export const getQuestionnaireTypeValue = (type: string): number => {
  switch (type) {
    case QuestionnaireType.SIMPLE:
      return 1;
    case QuestionnaireType.MAPPING:
      return 2;
    case QuestionnaireType.POC:
      return 3;
    case QuestionnaireType.GENERAL:
      return 4;
    case QuestionnaireType.SCORE:
      return 5;
    case QuestionnaireType.APPROVAL:
      return 6;
    case QuestionnaireType.CUSTOM:
      return 99;
    default:
      return 1;
  }
};

export const getQuestionnaireIcon = (
  type: QuestionnaireType
): React.ReactNode => {
  switch (type) {
    case QuestionnaireType.GENERAL:
      return React.createElement(GeneralIllustration);
    case QuestionnaireType.SIMPLE:
      return React.createElement(YesNo);
    case QuestionnaireType.MAPPING:
      return React.createElement(Mapping);
    case QuestionnaireType.POC:
      return React.createElement(TE);
    case QuestionnaireType.APPROVAL:
      return React.createElement(TEApproval);
    case QuestionnaireType.SCORE:
      return React.createElement(YesNo);
    default:
      return React.createElement(GeneralIllustration);
  }
};

export const getBadgeColors = (type: QuestionnaireType): string => {
  switch (type) {
    case QuestionnaireType.GENERAL:
      return "bg-teal-opacity border-teal-500 px-[6px] py-1";
    case QuestionnaireType.SIMPLE:
      return "bg-surface-tags-blue border-border-tags-blue px-[6px] py-1";
    case QuestionnaireType.MAPPING:
      return "bg-surface-tags-purple border-border-tags-purple px-[6px] py-1";
    case QuestionnaireType.APPROVAL:
    case QuestionnaireType.POC:
      return "bg-surface-tags-turquoise border-border-tags-turquoise px-[6px] py-1";
    default:
      return "bg-surface-tags-blue border-border-tags-blue px-[6px] py-1";
  }
};

export const getUserDisplayName = (
  userId: string | null,
  users: any[]
): string => {
  if (!userId) return "Unknown User";
  const user = users.find((u) => u.id === userId);
  return user ? user.displayName : "Unknown User";
};

export const getWorkflowTypeOptions = (t: (key: string) => string) => [
  {
    id: QuestionnaireType.SIMPLE,
    displayName: t("workflows.types.yesNoQuestionnaire"),
    disabled: false
  },
  {
    id: QuestionnaireType.GENERAL,
    displayName: t("workflows.types.general"),
    disabled: false
  }
  // {
  //   id: QuestionnaireType.SCORE,
  //   displayName: t("workflows.types.technicalEvaluation"),
  //   disabled: true,
  // },
  // {
  //   id: QuestionnaireType.APPROVAL,
  //   displayName: t("workflows.types.technicalEvaluationApproval"),
  //   disabled: true,
  // },
];

export const getWorkflowTypeValueFromId = (type: string): string => {
  switch (type) {
    case "general":
      return QuestionnaireType.GENERAL;
    case "yes-no-questionnaire":
      return QuestionnaireType.SIMPLE;
    case "technical-evaluation":
      return QuestionnaireType.SCORE;
    case "technical-evaluation-approval":
      return QuestionnaireType.APPROVAL;
    default:
      return QuestionnaireType.GENERAL;
  }
};
